module.exports = __webpack_public_path__ + "static/media/gif_SE_step_7.4eaf8b4e.gif";